<template>
  <div :style="{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }">
    <v-autocomplete
      v-model="form.id"
      :items="options"
      :placeholder="$t('Category')"
      :loading="loading"
      dense
      outline
      single-line
      hide-details
      clearable
      class="category-autocomplete"
    />
    <v-btn icon small color="primary" class="ma-0" @click="handleSubmit">
      <v-icon small>save</v-icon>
    </v-btn>
    <v-btn icon small flat color="primary" class="ma-0" @click="handleCancel">
      <v-icon small>close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    categoryId: {
      type: Number,
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: this.categoryId
      }
    }
  },
  methods: {
    handleSubmit() {
      this.loading = true
      this.$emit('submit', this.form, () => {
        this.loading = false
      })
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.category-autocomplete {
  /deep/ {
    .v-input__slot {
      min-height: auto;
    }
    .v-input__append-inner {
      margin-top: 0.25rem;
    }
    input {
      font-size: 0.875rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastItemCategoryEdit.vue